/**
 * English - `tipsStoreLocations`: the ⓘ explanations on the Store locations
 * screen and in the store locator section's settings.
 */
const tipsStoreLocations: Record<string, string> = {
  name: 'What shoppers call this branch, like "Koramangala" or "MG Road outlet". Shown as the heading of the location.',
  address_line1: 'The street address: shop number, building and street. Directions use it when there is no map pin.',
  address_line2: 'Optional. An area, landmark or floor, like "Near Forum Mall" or "2nd floor".',
  city: 'The city or town. Shoppers can search the list by city.',
  state: 'Optional. The state the shop is in.',
  pincode: 'Optional. The postal PIN code. Shoppers can search the list by PIN code.',
  phone: 'Optional. A number shoppers can tap to call this branch.',
  email: 'Optional. An email address for this branch. Kept for your records; it is sent with the location but not shown by the section.',
  latitude: 'Optional. The first number of the map pin, like 12.9716. In Google Maps, right-click the shop and click the numbers to copy them.',
  longitude: 'Optional. The second number of the map pin, like 77.5946. Enter both numbers or neither.',
  services: 'Optional. Short labels shoppers look for, like Dine-in, Parking or Wheelchair access. Separate them with commas.',
  is_active: 'Off hides this location from your storefront without deleting it - useful while a branch is being renovated.',
  show_hours: 'Off means no opening hours and no "open now" badge are shown for this location.',
  opens: 'When this branch opens on that day, in your store\'s timezone.',
  closes: 'When this branch closes on that day. It must be after the opening time.',
  closed: 'Tick for days this branch does not open.',
  'section.title': 'The heading above your locations, like "Find a store" or "Visit us".',
  'section.subtitle': 'Optional. A line under the heading, like "Fresh bread every morning at all our bakeries".',
  'section.layout': 'List shows one location under another. Cards shows them side by side. List with map adds a map of the chosen location, when it has a map pin.',
  'section.show_hours': 'Shows each location\'s week of opening hours and an "Open now" or "Closed now" badge, worked out in your store\'s timezone.',
  'section.show_phone': 'Shows each location\'s phone number as a tap-to-call link.',
  'section.show_directions': 'Adds a "Get directions" link that opens Google Maps in a new tab.',
  'section.search': 'Adds a box shoppers can type a city or PIN code into to narrow the list. Useful when you have many branches.',
};

export default tipsStoreLocations;
